import script from "./PreviewPdfModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewPdfModal.vue?vue&type=script&setup=true&lang=js"

import "./PreviewPdfModal.vue?vue&type=style&index=0&id=0400ffdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0400ffdc"]])

export default __exports__